<div *ngIf="!isViewStep; else viewStepModal" class="dialogue-container">
  <div class="flex img-container m-b-10">
    <img
      class="printer-status-image ta_center"
      src="{{ images.PRINTERS_URL }}printer-{{
        allPrintersActive ? 'connect' : 'disconnect'
      }}.svg"
      alt="printer-{{
        (allPrintersActive
          ? 'PRINTER_STATUS.CONNECTED'
          : 'PRINTER_STATUS.DISCONNECTED'
        ) | fallbackTranslate
      }}"
    />
    <img
      class="c-pointer img-40"
      id="printer_cancel"
      [src]="images.CLOSE_PRINTER"
      alt="cancel"
    />
  </div>
  <div class="printer-status-title ta_center clr-333 fw-600 lh-140">
    {{
      (allPrintersActive
        ? 'PRINTER_STATUS.ALL_PRINTERS_CONNECTED'
        : allPrintersDisconneted
        ? 'PRINTER_STATUS.ALL_PRINTERS_DISCONNECTED'
        : 'PRINTER_STATUS.SOME_PRINTERS_NOT_CONNECTED'
      ) | fallbackTranslate
    }}
  </div>
  <div class="flex_sa printer-icon p-t-4 m-b-8 br-4">
    <div class="flex_sb flex_column">
      <img [src]="images?.DEACTIVATED_PRINTER" class="img-28" alt="printer-icon"/>
      <p class="fs-14 fw-400 clr-333 m-b-0">{{'PRINTER_STATUS.DISCONNECTED' | fallbackTranslate}}</p>
    </div>
    <div class="flex_sb flex_column">
      <img [src]="images?.ACTIVATED_PRINTER" class="img-28" alt="printer-icon"/>
      <p class="fs-14 fw-400 clr-333 m-b-0">{{'PRINTER_STATUS.CONNECTED' | fallbackTranslate}}</p>
    </div>
    <div class="flex_sb flex_column">
      <p class="disabledCounter m-b-0 clr-999">{{'PRINTER_STATUS.COUNTER_NAME' | fallbackTranslate}}</p>
      <p class="fs-14 fw-400 clr-333 m-b-0">{{'PRINTER_STATUS.COUNTER_DISABLED' | fallbackTranslate}}</p>
    </div>
  </div>
  <div class="printer-footer flex_sb" *ngIf="!allPrintersActive">
    <div class="flex align_center">
      <img
        [src]="images.PRINTER_ICON"
        class="m-l-18"
        alt="{{ 'PRINTER_STATUS.PRINTER_LOGO' | fallbackTranslate }}"
      />
      <div class="reconnect-text m-b-0 m-l-12 clr-333 fw-700 lh-140">
        {{ 'PRINTER_STATUS.HOW_TO_RECONNECT_PRINTER' | fallbackTranslate }}
      </div>
    </div>
    <button
      nz-button
      nzType="link"
      class="m-l-10 m-r-10"
      (click)="switchToViewStep()"
    >
      {{ 'PRINTER_STATUS.VIEW_STEPS' | fallbackTranslate }}
      <span class="m-t-4" nz-icon nzType="right" nzTheme="outline"></span>
    </button>
  </div>
  <div class="printer-card-container">
    <ng-container
      *ngFor="let printer of allPrintersList; trackBy: trackPrinter"
    >
      <div
        class="printer-card"
        [ngClass]="
          printer?.isConnected
            ? 'connected'
            : printer?.isRetrying
            ? 'connecting'
            : 'disconnected'
        "
      >
        <div nz-row nzType="flex" nzAlign="middle" nzJustify="space-between">
          <div nz-col nzSpan="2" class="margin-top--15 icon-flex">
            <img
              [src]="
                images.PRINTERS_URL +
                (printer?.isConnected
                  ? 'success'
                  : printer?.isRetrying
                  ? 'retry'
                  : 'error') +
                '.svg'
              "
              alt="{{ 'PRINTER_STATUS.ICON_STATUS' | fallbackTranslate }}"
            />
          </div>
          <div nz-col nzSpan="14" class="info-flex">
            <div class="printer-card-info">
              <div class="flex align_center">
                <span class="primary-text" nz-title>
                  {{ isBluetoothPrinter(printer?.ip) ? 'Address: ' + printer?.ip : 'IP: ' + splitIP(printer?.ip) }}
                </span>
                <span
                  class="connection-tag"
                  [ngClass]="
                    printer?.isConnected
                      ? 'green-tag'
                      : printer?.isRetrying
                      ? 'yellow-tag'
                      : 'red-tag'
                  "
                >
                  {{
                    (printer?.isConnected
                      ? 'PRINTER_STATUS.CONNECTED'
                      : printer?.isRetrying
                      ? 'PRINTER_STATUS.CONNECTING'
                      : 'PRINTER_STATUS.NOT_CONNECTED'
                    ) | fallbackTranslate
                  }}
                </span>
              </div>
              <div>
                <ng-container *ngFor="let printerName of printer?.printersNameObj; let isLast = last;trackBy:trackByPrinterName">
                  <span [ngClass]="{'clr-333' : printerName?.status == printerStatusEnum?.ENABLED,
                                    'disabledCounter clr-999': printerName?.status == printerStatusEnum?.DISABLED
                                    }">
                    {{printerName?.name}}
                  </span>
                  <span *ngIf="!isLast">,</span>
                </ng-container>
              </div>
            </div>
          </div>
          <div nz-col nzSpan="7" class="retry-felx">
            <div class="printer-connection-status flex align_center">
              <ng-container *ngIf="!printer?.isConnected">
                <button
                  nz-button
                  nzType="link"
                  [disabled]="printer?.isRetrying"
                  (click)="retryPrinterConnection(printer)"
                >
                  <ng-container *ngIf="printer?.isRetrying; else reloadIcon">
                    <div class="spinner">
                      <img
                      class="m-r-5 img-20"
                      [src]="images.RETRY_ICON"
                      alt="{{ 'PRINTER_STATUS.RETRY' | fallbackTranslate }}"
                    />
                    </div>
                  </ng-container>
                  <ng-template #reloadIcon>
                    <img
                      class="m-r-5 img-20"
                      [src]="images.RETRY_ICON"
                      alt="{{ 'PRINTER_STATUS.RETRY' | fallbackTranslate }}"
                    />
                  </ng-template>
                  <u>{{
                    printer?.isRetrying
                      ? ''
                      : ('PRINTER_STATUS.RETRY' | fallbackTranslate)
                  }}</u>
                </button>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #viewStepModal>
  <div class="view-step-modal">
    <nz-spin [nzSpinning]="isLoading">
      <div class="view-step-header flex align_center">
        <button (click)="switchToViewStep()" class="m-r-12">
          <img
            [src]="images.BACK_BUTTON"
            alt="{{ 'PRINTER_STATUS.BACK_ICON' | fallbackTranslate }}"
          />
        </button>
        <div class="view-step-header-text fw-500 clr-333 lh-130">
          {{ 'PRINTER_STATUS.HOW_TO_RECONNECT_PRINTER' | fallbackTranslate }}
        </div>
      </div>
      <div class="view-step-body">
        <p class="warning-text fw-400 clr-333 lh-140">
          {{
            'PRINTER_STATUS.IF_YOUR_PRINTER_IS_UNABLE_TO_PRINT'
              | fallbackTranslate
          }}
        </p>

        <!-- Printer disconnected steps start -->
        <div class="printer-disconnect-step bg-fff">
          <div
            class="flex_sb collapse-title-wrapper c-pointer"
            (click)="performCollapseAction('disconnect')"
          >
            <div class="left-child flex_sb">
              <img [src]="images.PRINTER_STEP" class="img-36" alt="icon" />
              <div class="collapse-title clr-333 fw-700 lh-130 m-l-12">
                {{
                  'PRINTER_STATUS.CHECK_IF_PRINTER_IS_DISCONNECTED'
                    | fallbackTranslate
                }}
              </div>
            </div>

            <div class="right-child flex_sb">
              <div class="step-name fw-700 lh-130 ta_right m-r-10">
                {{
                  (isCollapsed.printerDisconnected
                    ? 'PRINTER_STATUS.HIDE_STEPS'
                    : 'PRINTER_STATUS.SHOW_STEPS'
                  ) | fallbackTranslate
                }}
              </div>

              <img
                [src]="images.ROTATING_ARROW"
                class="collapse-icon c-pointer rotate-{{
                  isCollapsed.printerDisconnected
                }}"
                alt="icon"
              />
            </div>
          </div>
          <ng-container *ngIf="isCollapsed.printerDisconnected">
            <div class="collapsed-content">
              <ul>
                <li *ngFor="let item of printerDisconnectedCollapsedContent">
                  <div class="step-wise-text fw-400 lh-140 clr-666">
                    {{ item?.text }}
                  </div>
                  <img *ngIf="item?.imgUrl && !item.videoUrl" [src]="item?.imgUrl" class="" alt="icon" />
                  <video class="video"  *ngIf="item?.imgUrl && item.videoUrl" controls  playsInline [poster]="item.imgUrl" width="100%">
                    <source [src]="item.videoUrl" type="video/mp4" />
                    {{
                      'PRINTER_STATUS.SORRY_YOUR_BROWSER_DOES_NOT_SUPPORT_EMBEDDED_VIDEOS' | fallbackTranslate
                    }}
                  </video>
                </li>
              </ul>
            </div>
          </ng-container>
        </div>
        <!-- Printer disconnected steps End -->

        <!-- Wifi settings steps start -->
        <div class="wifi-step bg-fff">
          <div
            class="flex_sb collapse-title-wrapper c-pointer"
            (click)="performCollapseAction('wifi')"
          >
            <div class="left-child flex_sb">
              <img [src]="images.WIFI_STEP" class="img-36" alt="icon" />
              <div class="collapse-title clr-333 fw-700 lh-130 m-l-12">
                {{
                  'PRINTER_STATUS.CHECK_YOUR_WIFI_SETTINGS' | fallbackTranslate
                }}
              </div>
            </div>

            <div class="right-child flex_sb">
              <div class="step-name fw-700 lh-130 ta_right m-r-10">
                {{
                  (isCollapsed.wifiSettings
                    ? 'PRINTER_STATUS.HIDE_STEPS'
                    : 'PRINTER_STATUS.SHOW_STEPS'
                  ) | fallbackTranslate
                }}
              </div>

              <img
                [src]="images.ROTATING_ARROW"
                class="collapse-icon c-pointer rotate-{{
                  isCollapsed.wifiSettings
                }}"
                alt="icon"
              />
            </div>
          </div>
          <ng-container *ngIf="isCollapsed.wifiSettings">
            <div class="collapsed-content">
              <ul>
                <li *ngFor="let item of wifiCollapsedContent">
                  <div class="step-wise-text fw-400 lh-140 clr-666">
                    {{ item?.text }}
                  </div>
                  <img
                    *ngIf="item?.imgUrl"
                    [src]="item?.imgUrl"
                    class=""
                    alt="icon"
                  />
                </li>
              </ul>
            </div>
          </ng-container>
        </div>
        <!-- Wifi settings steps end -->
      </div>
    </nz-spin>
  </div>
</ng-template>
